$(function() {
  $('.recommend').addClass('js-active');
  $('.recommend__message:nth-child(2)').addClass('slide-in');
  var displayTime = 4 * 1000;
  var delayBetweenSwitch = 1.2 * 1000;

  $('.recommend__message:nth-child(1)').on('animationend', function(event) {
    var animation = event.originalEvent.animationName;
    if (animation === 'slide-out') {
      $(this).addClass('js-hidden').removeClass('slide-out');

      $('.recommend__message:nth-child(2)').removeClass('js-hidden').addClass('slide-in');
    } else {
      $(this).addClass('slide-out').delay(displayTime).queue(function(next) {
          $(this).removeClass('slide-in').delay(delayBetweenSwitch).queue(function(next) {
            $(this).addClass('js-hidden');
            $('.recommend__message:nth-child(2)').addClass('slide-in').removeClass('js-hidden');
            next();
          });
          next();
      })
    }
  });

  $('.recommend__message:nth-child(2)').on('animationend', function(event) {
    var animation = event.originalEvent.animationName;
    if (animation === 'slide-out') {

      $(this).addClass('js-hidden').removeClass('slide-out');

      $('.recommend__message:nth-child(1)').removeClass('js-hidden').addClass('slide-in');

      } else {
        $(this).addClass('slide-out').delay(displayTime).queue(function(next) {
            $(this).removeClass('slide-in').delay(delayBetweenSwitch).queue(function(next) {
              $(this).addClass('js-hidden');
              $('.recommend__message:nth-child(1)').addClass('slide-in').removeClass('js-hidden');
              next();
            });
            next();
        })
      }
  });

});
